export abstract class CanvasValidationService {
  abstract isDrawingContained(canvas: HTMLCanvasElement, gutterPixelWidth?: number): boolean;
  abstract isDrawingComplex(canvas: HTMLCanvasElement, gutterPixelWidth?: number): boolean;
}
